module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "contact_form"
    }
  }, [_c('v-alert', {
    attrs: {
      "dismissible": "",
      "type": "success"
    },
    model: {
      value: (_vm.alertStatus),
      callback: function($$v) {
        _vm.alertStatus = $$v
      },
      expression: "alertStatus"
    }
  }, [_vm._v("This form was submitted successfully.")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "to",
    attrs: {
      "error-messages": _vm.errors.collect('to'),
      "items": _vm.people,
      "label": "To",
      "item-text": "text",
      "item-value": "value",
      "append-icon-cb": _vm.closeMenu,
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_vm._v(_vm._s(data.item.text))]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.text)
          }
        })], 1)]]
      }
    }]),
    model: {
      value: (_vm.data.to),
      callback: function($$v) {
        _vm.$set(_vm.data, "to", $$v)
      },
      expression: "data.to"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    attrs: {
      "counter": 20,
      "error-messages": _vm.errors.collect('from'),
      "data-vv-name": "from",
      "required": "",
      "label": "From"
    },
    model: {
      value: (_vm.data.from),
      callback: function($$v) {
        _vm.$set(_vm.data, "from", $$v)
      },
      expression: "data.from"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "error-messages": _vm.errors.collect('email'),
      "data-vv-name": "email",
      "required": "",
      "label": "Email"
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "d-flex": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:50'),
      expression: "'required|max:50'"
    }],
    attrs: {
      "counter": 50,
      "error-messages": _vm.errors.collect('subject'),
      "data-vv-name": "subject",
      "required": "",
      "label": "Subject"
    },
    model: {
      value: (_vm.data.subject),
      callback: function($$v) {
        _vm.$set(_vm.data, "subject", $$v)
      },
      expression: "data.subject"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "d-flex": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "name": "input-7-1",
      "label": "Message"
    },
    model: {
      value: (_vm.data.message),
      callback: function($$v) {
        _vm.$set(_vm.data, "message", $$v)
      },
      expression: "data.message"
    }
  })], 1)], 1), _vm._v(" "), _c('vue-recaptcha', {
    attrs: {
      "sitekey": "6LdddXsUAAAAAGHumerT5AvTLmu3ruDnZFCuY8M8"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm1($event)
      }
    }
  }, [_vm._v("Send Email")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d4a92ae4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact_form.vue
// module id = 99
// module chunks = 2